import React from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { getImageUrl } from "../utils/imageHelper";

const PALETTE = {
  PRIMARY_BLUE: "#6A9DD5",
  DARK_NAVY: "#1C2E4A",
  ACCENT_BROWN: "#7C4F2B",
};

const truncateText = (text, maxLength = 30) => {
  if (!text) return "";
  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const ProductCard = ({ product, cart, setCart }) => {
  const navigate = useNavigate();

  return (
    <div
      className="group w-full max-w-sm bg-white overflow-hidden transition-all duration-300 cursor-pointer flex flex-col h-full border border-gray-100 hover:shadow-lg"
      onClick={() => navigate(`/product/${product.slug}`)}
    >
      <div className="relative w-full h-48 sm:h-72 md:h-80 overflow-hidden shrink-0">
        <img
          src={getImageUrl(product.photos?.[0])}
          onError={(e) => {
            e.target.src = "/images/fallback-RB.png";
          }}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
        />
      </div>

      <div className="p-3 sm:p-5 flex flex-col flex-grow">
        <h3
          className="text-base sm:text-lg font-semibold text-gray-800 mb-1 tracking-wide"
          title={product.name}
        >
          {truncateText(product.name, 30)}
        </h3>

        <p
          className="hidden sm:block text-sm text-gray-500 mb-4"
          title={product.description}
        >
          {truncateText(product.description, 40)}
        </p>

        <div className="mt-auto">
          <div className="mb-3 sm:mb-4">
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
              <span
                className="text-lg sm:text-2xl font-bold"
                style={{ color: PALETTE.DARK_NAVY }}
              >
                ₹{product.price?.toLocaleString("en-IN")}
              </span>

              {product.actualPrice > product.price && (
                <span className="text-xs sm:text-base text-gray-400 line-through">
                  ₹{product.actualPrice?.toLocaleString("en-IN")}
                </span>
              )}
            </div>

            {product.actualPrice > product.price && (
              <div className="mt-1 sm:mt-2 flex items-center gap-2 flex-wrap">
                <span className="inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 sm:py-1 sm:px-3 text-[9px] sm:text-xs font-semibold text-green-700">
                  {Math.round(
                    ((product.actualPrice - product.price) /
                      product.actualPrice) *
                      100,
                  )}
                  % OFF
                </span>

                <span className="text-[9px] sm:text-xs text-gray-500">
                  You save ₹
                  {(product.actualPrice - product.price).toLocaleString(
                    "en-IN",
                  )}
                </span>
              </div>
            )}
          </div>

          <button
            className="w-full py-1.5 sm:py-2.5 px-3 sm:px-4 text-xs sm:text-sm tracking-wider uppercase font-bold text-black bg-transparent border-[1px] border-black transition-all duration-300 hover:bg-black hover:text-white"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/product/${product.slug}`);
            }}
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
